import '../../scss/talk.scss';

import {initSeeMore} from "../common/seeMoreResultInfiniteScroll";
import {initPlayers} from "../common/videoPlayer";

const $ = require('jquery');

document.addEventListener('DOMContentLoaded', () => {
    initFilter();
    initPlayers();
    initSeeMore(document.querySelector('.talk-list'), false);
});

const initFilter = () => {
    const filterCategory = $('#category');

    filterCategory.select2({
        allowClear: true,
        placeholder: filterCategory.attr('data-placeholder')
    });

    $('form.filters').on('submit', function () {
        $(this).find('select, input').each(function () {
            if (!$(this).val()) {
                $(this).prop('disabled', true);
            }
        })
    });

    filterCategory.on('change.select2', function () {
        $(this).closest('form').trigger('submit');
        $(this).prop('disabled', true);
    });
}
